import styled from '@emotion/styled'

import type { UseFormReturn } from 'react-hook-form'

import type { FC } from 'react'

import Divider from '@segment/matcha/components/Divider'

import Radio from '@segment/matcha/components/Radio'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import data from './data'
import type { QuizSchema } from './schema'

interface QuizProps {
  form: UseFormReturn<QuizSchema>
}

const Quiz: FC<QuizProps> = ({ form }) => {
  const { register } = form

  return (
    <StyledSection variant="centered">
      <Section.Copy>
        {data.map((item, index) => (
          <QuestionItem key={index}>
            <CopyTextBase>
              <CopyText.Overline>
                Question {index + 1} of {data.length}
              </CopyText.Overline>
              <CopyText.Heading variant="h4" tag="h2">
                {item.question}
              </CopyText.Heading>
            </CopyTextBase>

            <Answers>
              {Object.entries(item.answers).map(([key, { title }]) => (
                <Radio key={title} label={title} value={key} {...register(`answers.${index}`)} />
              ))}
            </Answers>

            {index + 1 < data.length ? <Divider /> : null}
          </QuestionItem>
        ))}
      </Section.Copy>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0px;
    padding-bottom: 0;
    gap: 0;
  }
`

const QuestionItem = styled.div`
  margin-bottom: 60px;

  ${({ theme }) => theme.breakpoints.down(`md`)} {
    margin-bottom: 30px;
  }
`

const Answers = styled.div`
  margin-top: 30px;
  margin-bottom: 60px;
  text-align: left;
  display: grid;
  gap: 20px;

  ${({ theme }) => theme.breakpoints.down(`md`)} {
    margin-bottom: 30px;
  }
`

export default Quiz
